
import { Route } from '@/app/router'

const Generations = () => import('./index.vue')

const GenerationsProps = ['page', 'perPage']

export default [
	new Route('/generations/:alternativeModelId?', Generations)
		.as('Dashboard:Generations')
		.permissions(['VIEW_VEHICLES'])
		.props(GenerationsProps)
]
